<!-- AlertModal.vue -->
<template>
  <b-modal
    v-model="showModal"
    size="md"
    hide-footer
    centered
    header-class="EditModalHeaderVariant"
    header-text-variant="white"
    :no-close-on-backdrop="true"
    :title="title"
    v-bind="setWorkEditInfo()"
  >
    <template v-slot:default>
      <div>
        <div>
          <!-- 区分 -->
          <div class="WorkM_InputGroupArea">
            <div class="WorkM_InputGroup_ItemLabel">区分</div>
            <div>
              <b-select size="sm" :state="isSegmentState" aria-describedby="input-live-feedback" :options="optionsWorkSegment" v-model="rewriteWorkSegment" @change="segmentState"></b-select>
              
              <b-form-invalid-feedback id="input-live-feedback">
                区分を選択してください
              </b-form-invalid-feedback>
            </div>
          </div>
          <!-- 時間 -->
          <b-form-group id="input-time-live-feedback" :invalid-feedback="messageHourState" :state="isHourState">
          <div class="d-flex mt-3">
            <div class="WorkM_InputGroupArea">
              <div class="WorkM_InputGroup_ItemLabel">時間 from</div>
              <div class="WorkM_InputTimeGroup WorkM_InputTime">
                <div class="WorkM_InputTimeGroup_InputItem">
                  <b-select size="sm" aria-describedby="input-time-live-feedback" :options="optionTimeHour" v-model="timeStartHour" @change="timeState"></b-select>
                </div>
                <div class="mx-1">:</div>
                <div class="WorkM_InputTimeGroup_InputItem">
                  <b-select size="sm" aria-describedby="input-time-live-feedback" :options="setOptionStartTimeMin" v-model="timeStartMin" @change="timeState"></b-select>
                </div>
              </div>
            </div>

            <div class="WorkM_InputGroupArea ml-3">
              <div class="WorkM_InputGroup_ItemLabel">時間 to</div>
              <div class="WorkM_InputTimeGroup WorkM_InputTime">
                <div class="WorkM_InputTimeGroup_InputItem">
                  <b-select size="sm" aria-describedby="input-time-live-feedback" :options="optionTimeHour" v-model="timeEndHour" @change="timeState"></b-select>
                </div>

                <div class="mx-1">:</div>
                <div class="WorkM_InputTimeGroup_InputItem">
                  <b-select size="sm" aria-describedby="input-time-live-feedback" :options="setOptionEndTimeMin" v-model="timeEndMin" @change="timeState"></b-select>
                </div>
              </div>
            </div>
          </div>
        </b-form-group>
          <!-- 工事 -->
          <b-form-group id="input-construction-live-feedback" :invalid-feedback="messageConstruction" :state="isConstructionState">
          <div class="WorkM_InputGroupArea mt-3" v-if="isAllocationCalc">
            <div class="WorkM_InputGroup_ItemLabel">工事</div>
            <div class="d-flex">
              <b-input 
              type="number" 
              size="sm" 
              placeholder="工事CD" 
              class="w-45" 
              v-model="rewriteConstructionCode" 
              @change="changeConstructionCode()"
              :disabled="!setAttendanceCheck"
               aria-describedby="input-construction-live-feedback"
              >
              </b-input>
              <b-input size="sm" readonly v-model="rewriteConstructionName"></b-input>
              <!-- <b-button variant="transparent" size="sm" class="WorkM_ButtonTempSuccess form-control-sm" :class="{'disabled': !setAttendanceCheck}" @click="setAttendanceCheck && btnSearchConstruction()"> -->
              <b-button variant="transparent" size="sm" class="WorkM_ButtonTempSuccess form-control-sm" :class="{'WorkEditModal_ButtonSearch': !setAttendanceCheck}" @click="btnSearchConstruction()" :disabled="!setAttendanceCheck">
                <b-icon icon="search"></b-icon>
              </b-button>
            </div>
          </div>
          </b-form-group>
          <!-- 事由 -->
          <div class="WorkM_InputGroupArea mt-3">
            <div class="WorkM_InputGroup_ItemLabel">事由</div>
            <div>
              <b-form-group 
              id="input-note-live-feedback" 
              invalid-feedback="事由の文字数を80字以内にしてください。"
              :state="noteSate()">
                <b-textarea 
                size="sm" 
                rows="2" 
                v-model="rewriteItemNote" >
                </b-textarea>
              </b-form-group>
            </div>
          </div>
          <!-- 災害 -->
          <div class="mt-2">
            <b-checkbox size="sm" class="text-danger" v-model="rewriteDisasterKbn" value=1 unchecked-value=0>災害</b-checkbox>
          </div>
        </div>
      </div>
      <div class="mt-5">
        <div v-if="addType === 0" class="d-flex justify-content-between">
          <div class="WorkM_Button WorkM_ButtonDanger" @click="btnWorkDelete()">削除</div>
          <div class="WorkM_Button WorkM_ButtonSuccess" @click="btnWorkEdit()">更新</div>
        </div>
        <div v-else class="d-flex justify-content-between flex-row-reverse">
          <div class="WorkM_Button WorkM_ButtonSuccess" @click="btnWorkRegist()">登録</div>
        </div>
      </div>
      <SearchConstructionModalVue ref="SearchConstructionModal" :loginUserId="userId" :targetType="searchConstructionNumber" @selectConstruction="setConstruction"></SearchConstructionModalVue>
    </template>
  </b-modal>
</template>

<script>
import config from "../../const/config";
import SearchConstructionModalVue from "../Modal/SearchConstructionModal.vue";
export default {
  name: "WorkEditModal",
  components: { SearchConstructionModalVue },
  props: {
    title: { type: String, default: "報告編集" },
    message: { type: String, default: "" },
    workDate: { type: String, default: "" },
    dateType: { type: Number, default: 0},
    userId: { type: String, default: "" },
    workSegment: { type: Number, default: 0 },
    detailNo: { type: Number, default: null },
    startTime: { type: String, default: "" },
    endTime: { type: String, default: "" },
    constructionCode: { type: String, default: null },
    constructionName: { type: String, default: "" },
    disasterKbn: { type: Number, default: 0 },
    itemNote: { type: String, default: "" },
    approvalKbn: { type: Number, default: 0 },
    addType:{type:Number,default:0},
    shiftStart: { type: String, default: "" }, // シフト開始時間
    shiftEnd: { type: String, default: "" }, // シフト終了時間
  },
  data: function () {
    return {
      showModal: false,
      rewriteWorkSegment: 0,
      rewriteConstructionCode: null,
      rewriteConstructionName: "",
      rewriteDisasterKbn: 0,
      rewriteItemNote: "",
      timeStartHour: 9,
      timeStartMin: 0,
      timeEndHour: 17,
      timeEndMin: 0,
      optionsWorkSegment: [],
      optionTimeHour: [
        { value: 0, text: "00" },
        { value: 1, text: "01" },
        { value: 2, text: "02" },
        { value: 3, text: "03" },
        { value: 4, text: "04" },
        { value: 5, text: "05" },
        { value: 6, text: "06" },
        { value: 7, text: "07" },
        { value: 8, text: "08" },
        { value: 9, text: "09" },
        { value: 10, text: "10" },
        { value: 11, text: "11" },
        { value: 12, text: "12" },
        { value: 13, text: "13" },
        { value: 14, text: "14" },
        { value: 15, text: "15" },
        { value: 16, text: "16" },
        { value: 17, text: "17" },
        { value: 18, text: "18" },
        { value: 19, text: "19" },
        { value: 20, text: "20" },
        { value: 21, text: "21" },
        { value: 22, text: "22" },
        { value: 23, text: "23" },
        { value: 24, text: "24" },
      ],
      optionTimeMin: [
        { value: 0, text: "00" },
        { value: 1, text: "01" },
        { value: 2, text: "02" },
        { value: 3, text: "03" },
        { value: 4, text: "04" },
        { value: 5, text: "05" },
        { value: 6, text: "06" },
        { value: 7, text: "07" },
        { value: 8, text: "08" },
        { value: 9, text: "09" },
        { value: 10, text: "10" },
        { value: 11, text: "11" },
        { value: 12, text: "12" },
        { value: 13, text: "13" },
        { value: 14, text: "14" },
        { value: 15, text: "15" },
        { value: 16, text: "16" },
        { value: 17, text: "17" },
        { value: 18, text: "18" },
        { value: 19, text: "19" },
        { value: 20, text: "20" },
        { value: 21, text: "21" },
        { value: 22, text: "22" },
        { value: 23, text: "23" },
        { value: 24, text: "24" },
        { value: 25, text: "25" },
        { value: 26, text: "26" },
        { value: 27, text: "27" },
        { value: 28, text: "28" },
        { value: 29, text: "29" },
        { value: 30, text: "30" },
        { value: 31, text: "31" },
        { value: 32, text: "32" },
        { value: 33, text: "33" },
        { value: 34, text: "34" },
        { value: 35, text: "35" },
        { value: 36, text: "36" },
        { value: 37, text: "37" },
        { value: 38, text: "38" },
        { value: 39, text: "39" },
        { value: 40, text: "40" },
        { value: 41, text: "41" },
        { value: 42, text: "42" },
        { value: 43, text: "43" },
        { value: 44, text: "44" },
        { value: 45, text: "45" },
        { value: 46, text: "46" },
        { value: 47, text: "47" },
        { value: 48, text: "48" },
        { value: 49, text: "49" },
        { value: 50, text: "50" },
        { value: 51, text: "51" },
        { value: 52, text: "52" },
        { value: 53, text: "53" },
        { value: 54, text: "54" },
        { value: 55, text: "55" },
        { value: 56, text: "56" },
        { value: 57, text: "57" },
        { value: 58, text: "58" },
        { value: 59, text: "59" },
      ],
      constructionWarn: null,
      disasterFlg: false,
      messageConstruction: null,
      isSegmentState: null,
      isHourState: null,
      messageHourState: null,
      isAllocationCalc: true, // 工事CD入力要否フラグ
      isConstructionState: true,
      noteMaxLength: 80, // 事由MAX文字数
      constructionCodeMaxLength: 8, // 工事コードMAX文字数
      searchConstructionNumber: 1, // 工事検索ポップアップ_画面種別
    };
  },
 
  mounted: function () {
    this.searchConstructionNumber = config.VALUE.DISPLAY_TYPE_WORK;
  },
  
  computed: {
    setAttendanceCheck: function(){
      let isAttendanceCheck = this.isAttendanceCheck();
      if(!isAttendanceCheck){
        this.setConstructionStateNull();
      }
      this.timeState();
      return isAttendanceCheck;
    },
    setOptionStartTimeMin: function(){
      if(this.timeStartHour == 24){
        this.setStartTimeMin(0);
        return [{ value: 0, text: "00" }];
      }
      else{
        return this.optionTimeMin;
      }
    },
    setOptionEndTimeMin: function(){
      if(this.timeEndHour == 24){
        this.setEndTimeMin(0);
        return [{ value: 0, text: "00" }]
      }
      else{
        return this.optionTimeMin;
      }
    }
  },
  methods: {
    setStartTimeMin(min){
      this.timeStartMin = min;
    },
    setEndTimeMin(min){
      this.timeEndMin = min;
    },
    segmentState() {
      this.isSegmentState = this.rewriteWorkSegment > 0 ? null: false
      return this.isSegmentState
    },
    // 就業区分が出勤系ではないかどうか
    isAttendanceCheck(){
      if(this.rewriteWorkSegment != 1 
      && this.rewriteWorkSegment != 11 
      && this.rewriteWorkSegment != 12 
      && this.rewriteWorkSegment != 21 
      && this.rewriteWorkSegment != 22
      && this.rewriteWorkSegment > 0){
        return false;
      }
      else{
        return true;
      }
    },
    timeState() {
      const MSG_ERR_TIME_REVERCE = "入力時間が逆転しています。";
      const MSG_ERR_TIME_EMPTY = "時間を入力してください。";
      const MSG_ERR_TIME_SAME = "FromとToに同じ時間が入力されています。";
      const MSG_ERR_SHIFT_START_BEFORE = "開始時刻にシフト開始以降の時間を入力してください。";
      const MSG_ERR_SHIFT_END_AFTER = "終了時刻にシフト終了以前の時間を入力してください。";

      // 時間入力欄の内一つでも値が入っていないならメッセージを表示
      if(isNaN(this.timeStartHour) || isNaN(this.timeStartMin) || isNaN(this.timeEndHour) || isNaN(this.timeEndMin)){
        console.log(MSG_ERR_TIME_EMPTY);
        this.messageHourState = MSG_ERR_TIME_EMPTY;
        this.isHourState = false;
        return this.isHourState;
      }

      // 入力された時間のToがFromよりも小さい値ならメッセージを表示
      if(this.timeStartHour > this.timeEndHour) {
        this.messageHourState = MSG_ERR_TIME_REVERCE;
        this.isHourState = false;
      } else if (this.timeStartHour == this.timeEndHour 
      && ((this.timeStartMin > this.timeEndMin) || (this.timeStartMin == this.timeEndMin))) {
        if (this.timeStartMin > this.timeEndMin) {
          this.messageHourState = MSG_ERR_TIME_REVERCE;
          this.isHourState = false;
        } else if (this.timeStartMin == this.timeEndMin) {
          this.messageHourState = MSG_ERR_TIME_SAME;
          this.isHourState = false;
        } else {
          this.isHourState = null;
        }
      } else {
        if (this.isLeaveCheck() || this.isLateCheck()) {
          const [shiftStartHourStr, shiftStartMinStr] = this.$props.shiftStart?.split(':');
          const [shiftEndHourStr, shiftEndMinStr] = this.$props.shiftEnd?.split(':');
          const shiftStartHour = parseInt(shiftStartHourStr);
          const shiftStartMin = parseInt(shiftStartMinStr);
          const shiftEndHour = parseInt(shiftEndHourStr);
          const shiftEndMin = parseInt(shiftEndMinStr);
          // 区分が「×(遅刻)」または「★他(早退)」の時
          if (this.timeStartHour < shiftStartHour) {
            // 入力された時間のFromがシフト開始よりも小さい値ならメッセージを表示
            this.messageHourState = MSG_ERR_SHIFT_START_BEFORE;
            this.isHourState = false;
          } else if (this.timeStartHour == shiftStartHour && this.timeStartMin < shiftStartMin) {
            // 入力された時間のFromがシフト開始よりも小さい値ならメッセージを表示
            this.messageHourState = MSG_ERR_SHIFT_START_BEFORE;
            this.isHourState = false;
          } else if (this.timeEndHour > shiftEndHour) {
            // 入力された時間のToがシフト終了よりも大きい値ならメッセージを表示
            this.messageHourState = MSG_ERR_SHIFT_END_AFTER;
            this.isHourState = false;
          } else if (this.timeEndHour == shiftEndHour && this.timeEndMin > shiftEndMin) {
            // 入力された時間のToがシフト終了よりも大きい値ならメッセージを表示
            this.messageHourState = MSG_ERR_SHIFT_END_AFTER;
            this.isHourState = false;
          } else {
            this.isHourState = null;
          }
        } else {
          this.isHourState = null;
        }
      }
      return this.isHourState;
    },
    constructionState: async function(){
      this.getConstructionValueFromAPI().then(()=>{
        return this.isConstructionState;
      })
    },
    openModal: function () {
      this.constructionWarn = null;
      this.showModal = true;
      this.messageHourState = null;
      this.isAllocationCalc = this.$store.state.flg_allocation_calc;
      this.isSegmentState = null;
      this.isHourState = true;
      this.isConstructionState = true;

      switch (this.dateType) {
        case config.VALUE.DATE_TYPE_HOLIDAY:
          this.optionsWorkSegment = config.OPTIONS.WORK_SEGMENT_HOLIDAY;
          break;
        case config.VALUE.DATE_TYPE_PUBLIC_HOLIDAY:
          this.optionsWorkSegment = config.OPTIONS.WORK_SEGMENT_PUBLIC_HOLIDAY;
          break;
        case config.VALUE.DATE_TYPE_WEEKDAY:
        default:
          this.optionsWorkSegment = config.OPTIONS.WORK_SEGMENT_WEEKDAY;
          break;
      }
    },
    handleOk: function () {
      this.showModal = false;
      this.$emit("handleOk");
    },
    // 登録ボタン押下時イベント（新規登録）
    btnWorkRegist: async function(){
      this.getConstructionValueFromAPI().then(()=>{

        // 各入力項目について登録前の確認を行なう
        //=====================================
        let isValidSegment= this.segmentState();
        if(isValidSegment == null){
          isValidSegment = true;
        }
        let isValidTime = this.timeState();
        if(isValidTime == null){
          isValidTime = true;
        }
        // 事由の文字数は指定文字数以下か？
        if(!this.noteSate()){
          return;
        }
        let isAttendance = this.isAttendanceCheck();
        // 割賦配布ではない、または就業区分が出勤系ではない、または工事コードが正常、
        const isValidConstruction = !this.isAllocationCalc || !isAttendance ||this.isConstructionState;
        if(!isValidSegment || !isValidTime || !isValidConstruction){
          return;
        }
        //=======================================
        
        // 送信前のパラメータ設定
        let constructionCode = (this.rewriteConstructionCode == "" || !isAttendance) ? 0 : this.rewriteConstructionCode;
        let constructionName = !isAttendance ? "" : this.rewriteConstructionName;
        let json = {
          workDate:this.workDate,
          shainCd:this.userId,
          workSegment:this.rewriteWorkSegment,
          startTime:this.optionTimeHour[this.timeStartHour].text + ":" + this.optionTimeMin[this.timeStartMin].text,
          endTime:this.optionTimeHour[this.timeEndHour].text + ":" + this.optionTimeMin[this.timeEndMin].text,
          constructionCode:constructionCode,
          constructionName:constructionName,
          itemNote:this.rewriteItemNote,
          disasterKbn:this.rewriteDisasterKbn,
        };
        console.debug("json：" + JSON.stringify(json));

        // 登録前ポップアップ
        let message = "以下の報告を登録します。"
                    + "<br>・区分：" + this.getDispSegment(json.workSegment)
                    + "<br>・日付：" + this.getStrDateSlash(json.workDate) + "(" + this.getDayOfWeek(json.workDate) + ")"
                    + "<br>・時間：" + json.startTime
                    + " ～ " + json.endTime
                    + "<br>よろしいですか？";
        this.$confirm(message, "確認", {
          confirmButtonText: "OK",
          cancelButtonText: "キャンセル",
            dangerouslyUseHTMLString: true,
            customClass:"editCheckModalWidthHeader"
        }).then(() => {
          // 新規登録
          this.postData(config.URL.WORK_REGIST, json)
            .then((response) => {
              console.debug("response：" + JSON.stringify(response));
              // レスポンスの結果がfalseならエラーメッセージを表示
              if(!response.result){
                this.showAlertError(response.message);
                return;
              }
              this.$emit("getWorkRegistInfo");
              this.showModal = false;
              this.$emit("handleOk");
            })
            .catch((e) => {
              // Note: エラーメッセージは、共通処理で表示している
              console.error(e);
            })
            .finally(() => {});
        });
      })
    },
    // 更新ボタン押下時イベント（更新）
    btnWorkEdit: async function(){

      this.getConstructionValueFromAPI().then(()=>{
        // 各入力項目について登録前の確認を行なう
        //=====================================
        let isValidSegment= this.segmentState();
        if(isValidSegment == null){
          isValidSegment = true;
        }
        let isValidTime = this.timeState();
        if(isValidTime == null){
          isValidTime = true;
        }
        let isAttendance = this.isAttendanceCheck();
        // 事由の文字数は指定文字数以下か？
        if(!this.noteSate()){
          return;
        }
        // 割賦配布ではない、または就業区分が出勤系ではない、または工事コードが正常、
        const isValidConstruction = !this.isAllocationCalc || !isAttendance ||this.isConstructionState;
        if(!isValidSegment || !isValidTime || !isValidConstruction){
          return;
        }
        //=======================================

        // 送信前のパラメータ設定
        let constructionCode = (this.rewriteConstructionCode == "" || !isAttendance) ? 0 : this.rewriteConstructionCode;
        let constructionName = !isAttendance ? "" : this.rewriteConstructionName;
        let json = {
          workDate:this.workDate,
          shainCd:this.userId,
          workSegment:this.rewriteWorkSegment,
          detailNo:this.detailNo,
          startTime:this.optionTimeHour[this.timeStartHour].text + ":" + this.optionTimeMin[this.timeStartMin].text,
          endTime:this.optionTimeHour[this.timeEndHour].text + ":" + this.optionTimeMin[this.timeEndMin].text,
          constructionCode:constructionCode,
          constructionName:constructionName,
          itemNote:this.rewriteItemNote,
          disasterKbn:this.rewriteDisasterKbn,
        };
        console.debug("json：" + JSON.stringify(json));
        
        // 更新前ポップアップ
        let message = "報告を以下の通りに更新します。"
                    + "<br>・区分：" + this.getDispSegment(json.workSegment)
                    + "<br>・日付：" + this.getStrDateSlash(json.workDate) + "(" + this.getDayOfWeek(json.workDate) + ")"
                    + "<br>・時間：" + json.startTime
                    + " ～ " + json.endTime
                    + "<br>よろしいですか？";
        this.$confirm(message, "確認", {
          confirmButtonText: "OK",
          cancelButtonText: "キャンセル",
          dangerouslyUseHTMLString: true,
          customClass:"editCheckModalWidthHeader"
        }).then(() => {
          // 更新
          this.putData(config.URL.WORK_REGIST, null, json)
            .then((response) => {
              console.debug("response：" + JSON.stringify(response));
              // レスポンスの結果がfalseならエラーメッセージを表示
              if(!response.result){
                this.showAlertError(response.message);
                return;
              }
              this.$emit("getWorkRegistInfo");
              this.showModal = false;
              this.$emit("handleOk");
            })
            .catch((e) => {
              // Note: エラーメッセージは、共通処理で表示している
              console.error(e);
            })
            .finally(() => {});
        });
      })
    },
    // 削除ボタン押下時イベント
    btnWorkDelete: function(){
      let shainCd = this.userId;
      
      let message = "以下の報告を削除します。"
                  + "<br>・区分：" + this.getDispSegment(this.$props.workSegment)
                  + "<br>・日付：" + this.getStrDateSlash(this.workDate) + "(" + this.getDayOfWeek(this.workDate) + ")"
                  + "<br>・時間：" + this.$props.startTime
                  + " ～ " + this.$props.endTime
                  + "<br>よろしいですか？";
        this.$confirm(message, "確定", {
          confirmButtonText: "OK",
          cancelButtonText: "キャンセル",
          dangerouslyUseHTMLString: true,
          customClass:"editCheckModalWidthHeader"
        }).then(() => {
          this.deleteDataMultiKey(config.URL.WORK_REGIST, shainCd, this.detailNo)
            .then((response) => {
              console.debug("response：" + JSON.stringify(response));
              // レスポンスの結果がfalseならエラーメッセージを表示
              if (!response.result) {
                this.showAlertError(response.message);
                return;
              }
              this.$emit("getWorkRegistInfo");
              this.showModal = false;
              this.$emit("handleOk");
            })
            .catch((e) => {
              // Note: エラーメッセージは、共通処理で表示している
              console.error(e);
            })
            .finally(() => {});
        });
    },
    // propsの情報を基に画面に表示する内容をセット
    setWorkEditInfo: function(){
      // 画面に表示する内容をpropsから取得
      this.rewriteWorkSegment = this.$props.workSegment;
      this.rewriteConstructionCode = (this.$props.constructionCode == "0" ? "" : this.$props.constructionCode);
      this.rewriteConstructionName = (this.$props.constructionCode == "0" ? "" : this.$props.constructionName);
      this.rewriteDisasterKbn = this.$props.disasterKbn;
      this.rewriteItemNote = this.$props.itemNote;

      const [timeStartHourStr, timeStartMinStr] = this.$props.startTime.split(':');
      const [timeEndHourStr, timeEndMinStr] = this.$props.endTime.split(':');
      this.timeStartHour = parseInt(timeStartHourStr);
      this.timeStartMin = parseInt(timeStartMinStr);
      this.timeEndHour = parseInt(timeEndHourStr);
      this.timeEndMin = parseInt(timeEndMinStr);
    },
    // 検索ボタン押下時イベント
    btnSearchConstruction: function(){
      this.$refs.SearchConstructionModal.openModal();
    },
    // 工事検索ポップアップから帰ってきた値をセット
    setConstruction: function(value){
      this.rewriteConstructionCode = value.constructionCode;
      this.rewriteConstructionName = value.constructionName;
      this.isConstructionState = true;
    },
    // 工事入力内容変更時の動作
    changeConstructionCode: function(){
      this.getConstructionValueFromAPI();
    },
    // APIから工事コードにあった工事名を取得する
    getConstructionValueFromAPI: async function(){
      if (this.rewriteConstructionCode?.length > this.constructionCodeMaxLength) {
        this.rewriteConstructionName = null;
        this.messageConstruction = "工事コードの文字数を" + this.constructionCodeMaxLength + "桁以内にしてください。";
        this.isConstructionState = false;
        return;
      }
      if (!this.isAllocationCalc || !this.isAttendanceCheck()) {
        return;
      }
      if (this.rewriteConstructionCode == null || this.rewriteConstructionCode == "") {
                this.rewriteConstructionName = null;
                this.isConstructionState = false;
                this.messageConstruction = "工事コードを入力してください。";
                return;
      }
      let paramList = {
          shainCd: this.userId,
          constructionCd: this.rewriteConstructionCode
      };
      await this.getWithParams(config.URL.KOUJI_INFO, paramList)
          .then((response) => {
              console.debug("response：" + JSON.stringify(response));
              // レスポンスの結果がfalseならエラーメッセージを表示
              if (!response.result) {
                this.showAlertError(config.MESSAGE.SERVER_ERROR);
                this.rewriteConstructionName = null;
                this.isConstructionState = false;
                return;
              }
              if (response.container == null) {
                this.rewriteConstructionName = null;
                this.isConstructionState = false;
                const MSG_ERR_CONSTRUCTION_INVALID = "該当する工事コードが見つかりませんでした。";
                this.messageConstruction = MSG_ERR_CONSTRUCTION_INVALID;
              } else {
                this.setConstructionValue(response.container);
                this.isConstructionState = true;
              }
          })
          .catch((e) => {
              // Note: エラーメッセージは、共通処理で表示している
              console.error(e);
          })
          .finally(() => {
          });
    },
    // 区分コードを基に区分名を取得
    // segmentCd:区分コード
    getDispSegment: function (segmentCd) {
      let optionSegment = config.OPTIONS.WORK_SEGMENT;
      let result = "";
      optionSegment.forEach((element) => {
        if (element.value == segmentCd) {
          result = element.text;
        }
      });
      return result;
    },
    disasterKbnChange: function(){
      if(this.rewriteDisasterKbn == 0){
        this.rewriteDisasterKbn = 1;
        return true;
      } else {
        this.rewriteDisasterKbn = 0;
        return false;
      }
    },
    setConstructionValue: function(items){
      this.rewriteConstructionName = items.name;
    },
    // 事由文字数チェック
    noteSate(){
      return this.rewriteItemNote?.length <= this.noteMaxLength || this.emptyCheck(this.rewriteItemNote);
    },
    // 空文字かチェック
    // true: 空文字
    // false: 空文字ではない
    emptyCheck(text){
      if(text != null && text != ""){
        return false;
      } else {
        return true;
      }
    },
    setConstructionStateNull: function(){
      this.isConstructionState = null;
    },
    
    // ×(遅刻)かチェックする
    // true：×(遅刻)
    // false
    isLateCheck: function(){
      const WORK_SEGMENT_LATE = 8; // ×(遅刻)

      if (this.rewriteWorkSegment != WORK_SEGMENT_LATE) {
        return false;
      } else {
        return true;
      }
    },
    // ★その他(早退)かチェックする
    // true：★その他(早退)
    // false
    isLeaveCheck: function(){
      const WORK_SEGMENT_LEAVE = 9; // ★その他(早退)

      if (this.rewriteWorkSegment != WORK_SEGMENT_LEAVE) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>
<style>
.WorkM_InputGroup_ItemLabel {
  font-size: 0.85rem;
  color: rgb(13, 91, 136);
  font-weight: 700;
  margin: 0;
}
.WorkM_InputTimeGroup {
  display: flex;
}
.WorkM_InputTime .WorkM_InputTimeGroup_InputItem {
  width: 3.5rem;
}
.EditModalHeaderVariant {
  background-color: rgb(13, 91, 136);
}
.WorkEditModal_ButtonSearch{
  background-color: rgba(45, 101, 175, 1) !important;
  color: white !important;
}
input:invalid{
  background: none !important;
}
.WorkM_InputGroupArea option[disabled="disabled"]{
  display: none;
}
</style>
